import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';
import { WALLS_COULD_TALK } from './homeDummyContent';

/**
 * Peerspace “If walls could talk” — editorial / blog-style cards (dummy).
 */
const MarketingStoriesBand = () => {
  return (
    <section className="bg-m-surface px-4 py-20 sm:px-6 sm:py-28">
      <MarketingReveal className="mx-auto w-full max-w-6xl">
        <div className="mb-12 flex flex-col gap-4 sm:mb-16 sm:flex-row sm:items-end sm:justify-between">
          <div className="max-w-2xl">
            <h2 className="marketing-section-title mb-3 text-m-ink">
              If walls could talk
            </h2>
            <p className="marketing-body-lg text-m-ink-muted">
              Stories, tips, and host notes from the parties booked on VendaList —
              all dummy copy for now.
            </p>
          </div>
          <Link
            to="/blog"
            className="group inline-flex shrink-0 items-center gap-1.5 text-sm font-medium text-m-ink transition-opacity hover:opacity-70"
          >
            Read the journal
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </div>

        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:gap-10">
          {WALLS_COULD_TALK.map((story) => (
            <Link
              key={story.id}
              to={story.href}
              className="group flex flex-col overflow-hidden rounded-2xl border border-m-border-light transition-colors hover:border-m-ink/30"
            >
              <div className="overflow-hidden">
                <img
                  src={story.image}
                  alt=""
                  className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-1 flex-col p-5 sm:p-6">
                <p className="mb-2 text-[11px] font-medium uppercase tracking-[0.14em] text-m-ink-faint">
                  {story.eyebrow}
                </p>
                <h3 className="mb-2 text-xl font-medium tracking-tight text-m-ink">
                  {story.title}
                </h3>
                <p className="marketing-body flex-1 text-m-ink-muted">{story.body}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-m-ink">
                  Keep reading
                  <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingStoriesBand;
